import { Model } from "@vuex-orm/core";
import Message from "./Message";
import Note from "./Note";

export default class User extends Model {
  static entity = "users";

  static fields() {
    return {
      authUid: this.attr(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      lastActivityAt: this.number(Date.now()),
      accountId: this.number(0),
      authRoleId: this.number(0),
      id: this.attr(),
      isDirty: this.boolean(false),
      firstName: this.attr(),
      lastName: this.attr(),
      email: this.attr(),
      currentCustomerId: this.number(0),
      mobilePhoneNumber: this.attr(),
      roles: this.attr(),

      messages: this.hasMany(Message, "userId"),
      notes: this.hasMany(Note, "userId")
    };
  }

  get shortName() {
    return [this.firstName, this.lastName.charAt(0)].join(" ").trim();
  }

  get longName() {
    return [this.firstName, this.lastName].join(" ").trim();
  }

  get initials() {
    return this.firstName.charAt(0) + this.lastName.charAt(0);
  }

  get mobilePhoneNumberDisplay() {
    let cleaned = ("" + this.mobilePhoneNumber).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return "";
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
